import { PORTUGUESE } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Portuguese
const ESSection: Section[] = [
  {
    name: '1: Referência e visão geral',
    subSections: [
      {
        name: 'Apresentação',
        page: 3,
      },
      {
        name: 'Propósito e aplicabilidade do guia de campo',
        page: 4,
      },
      {
        name: 'Principais definições',
        page: 5,
      },
      {
        name: 'Hierarquia dos controles',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Veículo motorizado: segurança no trânsito',
        page: 9,
      },
      {
        name: 'Trabalho em altura',
        page: 12,
      },
      {
        name: 'Equipamento elétrico móvel (MPE)',
        page: 18,
      },
      {
        name: 'Bloqueio e Etiquetagem / Isolamento de energia',
        page: 22,
      },
      {
        name: 'Trabalho elétrico',
        page: 25,
      },
      {
        name: 'Espaço confinado',
        page: 29,
      },
      {
        name: 'Material a granel e armazenamento',
        page: 32,
      },
      {
        name: 'Segurança ferroviária',
        page: 37,
      },
      {
        name: 'Trabalho em escavações e fossos',
        page: 41,
      },
      {
        name: 'Içamento e Amarração',
        page: 45,
      },
      {
        name: 'Materiais perigosos',
        page: 49,
      },
      {
        name: 'Trabalho a quente',
        page: 52,
      },
    ],
  },
  {
    name: '3: Ferramentas e recursos adicionais',
    subSections: [
      {
        name: 'Trabalho acima ou próximo da água',
        page: 56,
      },
      {
        name: 'Queda de objetos',
        page: 59,
      },
      {
        name: 'Teste de gás/atmosférico',
        page: 61,
      },
      {
        name: 'Comunicação de risco químico',
        page: 65,
      },
    ],
  },
  {
    name: '4: Práticas de gestão de segurança da Cargill',
    subSections: [
      {
        name: 'Principal terminologia',
        page: 70,
      },
      {
        name: 'Determinação de evento de Acidentes graves e fatalidades (SIF)',
        page: 72,
      },
      {
        name: 'Categorização de Acidentes graves e fatalidades potenciais (SIFp)',
        page: 73,
      },
      {
        name: 'Tabela de critérios de determinação automática de SIF',
        page: 74,
      },
      {
        name: 'Desempenho humano e organizacional (HOP)',
        page: 76,
      },
    ],
  },
];
const ESTableofContent: TableOfContent = {
  language: 'pt',
  sections: ESSection,
  label: 'Índice',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (pt_BR)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Guia Prático de HOP',
  hopPocketLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Portuguese (Brazil).pdf',
  source: PORTUGUESE,
};

export default ESTableofContent;
